import React from 'react'
import { Typography } from '@s4l/ds'
import { IconCheck } from '@s4l/icons/IconCheck'
import styles from './index.module.css'

interface CheckItemProps {
  text: string
}

const CheckItem: React.FC<CheckItemProps> = ({ text }) => {
  return (
    <div className={styles.checkItem}>
      <IconCheck className={styles.checkIcon} />
      <Typography variant="body" size="l">
        {text}
      </Typography>
    </div>
  )
}

export default CheckItem
